module.exports = __webpack_public_path__ + "static/media/JoannaPreston_resume.d1480ad3.pdf";